module.exports = __webpack_public_path__ + "static/media/Lawrance Gardens.63abbddb.mp3";